import classNames from "classnames";
import React from "react";

import styles from "./PageContent.module.css";

type PropTypes = {
  centered?: boolean;
};

const PageContent: React.FC<React.PropsWithChildren<PropTypes>> = ({ children, centered = true }) => {
  return <div className={classNames(styles.pageContent, { [styles.centered]: centered })}>{children}</div>;
};

export default PageContent;
